import { render, staticRenderFns } from "./OrgsAdminDashboard.vue?vue&type=template&id=218069e1&"
import script from "./OrgsAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./OrgsAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports